export interface IConnectionsStep {
  key: string;
  title: string;
  description?: string;
  component: string;
  path: string;
}

export const enum OnboardingSuggestedProductPathKey {
  PublicPortfolio = 'public_portfolio',
  PerformanceIndex = 'performance_index',
  WarRoom = 'war_room',
  Academy = 'academy',
  Jobs = 'jobs',
  JobsProfile = 'jobs_profile',
}
